<div class="content-body">
  <form [formGroup]="debitNoteForm">
    <div class="d-flex gap-30">
      <div class="form-field">
        <p>Debit Note No. <span class="text-danger-300">*</span></p>
        <mat-form-field>
          <input
            maxlength="{{ maxLength.maxLength100 }}"
            matInput
            formControlName="debitNoteNo"
            autocomplete="off"
          />
        </mat-form-field>
      </div>
      <div class="form-field datepicker">
        <p>Entry Date</p>
        <mat-form-field appearance="fill">
          <input
            matInput
            formControlName="entryDate"
            [matDatepicker]="entryDate"
            autocomplete="off"
            (change)="commonService.validateDate($event)"
            (dateChange)="dateChange()"
            [min]="minInvoiceDate"
            [max]="maxInvoiceDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="entryDate"
          ></mat-datepicker-toggle>
          <mat-datepicker #entryDate></mat-datepicker>
        </mat-form-field>
        <mat-error
          *ngIf="
            commonService.checkDateValidation(debitNoteForm.get('entryDate'))
              .invalidFinancialYear
          "
        >
          {{ notificationMessage.validPeriodDateMessage }}
        </mat-error>

        <mat-error
          *ngIf="
            commonService.checkDateValidation(debitNoteForm.get('entryDate'))
              .lockedFinancialYear
          "
        >
          {{ notificationMessage.lockedAccoutingPeriodDateMessage }}
        </mat-error>
      </div>
    </div>
    <div class="d-flex gap-30">
      <div class="form-field quick-add-buttons">
        <div class="d-flex justify-space-between">
          <p>Supplier Name <span class="text-danger-300">*</span></p>
          <span>
            <button
              mat-button
              disableRipple
              [disabled]="!isSupplierChangePermission"
            >
              <mat-icon (click)="gotoAddSupplier()" title="add"
                >add_circle_outline</mat-icon
              >
            </button>
            <button
              [disabled]="disabledEditButton || !isSupplierChangePermission"
              mat-button
              disableRipple
            >
              <mat-icon
                (click)="gotoEditSupplier()"
                fontSet="material-icons-outlined"
                title="edit"
                >edit</mat-icon
              >
            </button>
          </span>
        </div>
        <ng-select
          #accountId
          [disableOptionCentering]="true"
          (focus)="accountId.open()"
          (valueChange)="accountId.close()"
          formControlName="accountId"
          panelClass="mat-select-position"
          (change)="onSupplierChange(); supplierChange($event)"
        >
          <ng-option *ngFor="let cl of supplierList" [value]="cl.id">
            <div title="{{ cl.name }}">{{ cl.name }}</div>
          </ng-option>
        </ng-select>
      </div>
      <div class="form-field">
        <p>Bill Ref. No.</p>
        <mat-form-field>
          <input
            matInput
            formControlName="billRefNo"
            autocomplete="off"
            maxlength="{{ maxLength.maxLength100 }}"
          />
        </mat-form-field>
      </div>
    </div>
    <div class="d-flex gap-30">
      <div class="form-field">
        <p>Account Name <span class="text-danger-300">*</span></p>
        <mat-form-field appearance="fill">
          <input
            type="text"
            matInput
            formControlName="debitNoteType"
            required
            [matAutocomplete]="accountGroup"
            (keyup)="onAccountSearch($event)"
            (mousedown)="resetAccountList()"
            #projectTrigger="matAutocompleteTrigger"
            appAutocompletePosition="projectTrigger"
          />
          <mat-icon matSuffix>keyboard_arrow_down</mat-icon>
          <mat-autocomplete
            [displayWith]="getOptionText"
            (opened)="
              scrollIntoView(debitNoteForm.controls.debitNoteType.value)
            "
            #accountGroup="matAutocomplete"
          >
            <mat-optgroup
              *ngFor="let group of debitNoteTypeList"
              [label]="group.groupName"
              title="{{ group.groupName }}"
            >
              <mat-option
                *ngFor="let names of group.listModels"
                [value]="names"
                title="{{ names.name }}"
                [class]="
                  this.debitNoteForm.controls.debitNoteType.value.id ===
                  names.id
                    ? 'mat-selected'
                    : ''
                "
              >
                {{ names.name }}
              </mat-option>
            </mat-optgroup>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="form-field quick-add-buttons">
        <div class="d-flex justify-space-between">
          <p>Fund Name <span class="text-danger-300">*</span></p>
          <span>
            <button
              mat-button
              disableRipple
              [disabled]="!isFundChangePermission"
            >
              <mat-icon (click)="gotoAddFund()" title="add"
                >add_circle_outline</mat-icon
              >
            </button>
            <button
              [disabled]="disabledFundEditButton || !isFundChangePermission"
              mat-button
              disableRipple
            >
              <mat-icon
                (click)="gotoEditFund()"
                fontSet="material-icons-outlined"
                title="edit"
                >edit</mat-icon
              >
            </button>
          </span>
        </div>
        <ng-select
          #fundName
          (focus)="fundName.open()"
          (valueChange)="fundName.close()"
          [disableOptionCentering]="true"
          formControlName="fundName"
          panelClass="mat-select-position"
          (change)="fundChange($event)"
        >
          <ng-option *ngFor="let fn of fundNameList" [value]="fn.id">
            <div class="clamp" title="{{ fn.name }}">{{ fn.name }}</div>
          </ng-option>
        </ng-select>
      </div>
    </div>
    <div class="d-flex gap-30 align-items-center">
      <div class="form-field">
        <p>Currency <span class="text-danger-300">*</span></p>
        <mat-form-field>
          <mat-select
            [disableOptionCentering]="true"
            formControlName="currency"
            panelClass="mat-select-position"
          >
            <mat-option
              *ngFor="let cl of currencyList"
              [value]="cl.id"
              title="{{ cl.country }} - {{ cl.name }} - {{ cl.code }}"
              >{{ cl.country }} - {{ cl.name }} - {{ cl.code }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="form-field m-0" *ngIf="isVatRegistered">
        <mat-checkbox
          formControlName="isVatInclude"
          (change)="onCheckBoxSelected($event)"
        >
          Amount Including VAT
        </mat-checkbox>
      </div>
    </div>
    <div class="d-flex gap-30">
      <div *ngIf="this.isFromBankImport" class="form-field">
        <p>Import Bank payment</p>
        <mat-form-field>
          <input matInput formControlName="amountReceived" autocomplete="off" />
        </mat-form-field>
      </div>
    </div>
    <div class="form-field wp-100 textarea">
      <p>Notes</p>
      <mat-form-field>
        <textarea
          maxlength="{{ maxLength.maxLength2000 }}"
          matInput
          formControlName="note"
          autocomplete="off"
        ></textarea>
      </mat-form-field>
    </div>
  </form>
</div>
